import { QUERY_KEYS } from 'api/query-keys';
import { accreditationsService } from 'hq/services';
import {
  AccreditationRejectionReason,
  AccreditationType,
} from 'hq/services/accreditations-service.types';
import { useMutation, useQueryClient } from 'react-query';

type RejectAccreditationParams = {
  flexWorkerId: string;
  certificateId: string;
  accreditationType: AccreditationType;
  rejectionReason: AccreditationRejectionReason;
};

export const useRejectAccreditation = () => {
  const mutationFn = async ({
    flexWorkerId,
    certificateId,
    accreditationType,
    rejectionReason,
  }: RejectAccreditationParams) =>
    await accreditationsService.rejectAccreditation(
      flexWorkerId,
      certificateId,
      accreditationType,
      rejectionReason
    );
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.accreditations());
    },
  });
};
